import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  AiAssetListBlock,
  AiAssetRelationSummary,
} from '../../models/ai-assistant.models';

@Component({
  selector: 'app-response-asset-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-asset-list.component.html',
  styleUrl: './response-asset-list.component.css',
})
export class ResponseAssetListComponent {
  private readonly defaultRelationPreviewLimit = 1;
  private readonly frameworkPreviewLimit = 3;

  @Input({ required: true }) block!: AiAssetListBlock;

  labelClass(value: string): string {
    return `tone-${value.toLowerCase().replace(/\s+/g, '-')}`;
  }

  visibleIds(summary: AiAssetRelationSummary): string[] {
    return summary.ids.slice(0, this.previewLimit(summary));
  }

  hiddenCount(summary: AiAssetRelationSummary): number {
    return Math.max(summary.total - this.visibleIds(summary).length, 0);
  }

  private previewLimit(summary: AiAssetRelationSummary): number {
    return summary.label.toLowerCase().includes('framework')
      ? this.frameworkPreviewLimit
      : this.defaultRelationPreviewLimit;
  }
}
